export const branchHeaders = {
    BRANCH_CODE : 'Branch Code',
    BRANCH_NAME : 'Branch Name'
}